import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Features() {
  const { t } = useTranslation();

  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="w-full px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 text-xs font-medium text-foreground-600 mb-6">
            {t('features.label', 'Key Benefits')}
          </span>
          <h2 className="text-3xl md:text-[42px] font-bold text-foreground-950 leading-tight">
            {t('features.title_line1', 'Smart Features for')}
            <br />
            {t('features.title_line2', 'Smarter Sourcing')}
          </h2>
          <p className="mt-4 text-foreground-600 text-base max-w-xl mx-auto">
            {t('features.subtitle')}
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {/* Card 1 */}
          <div className="group rounded-2xl bg-secondary-50 p-8 hover:bg-primary-500 transition-colors duration-300 cursor-default">
            <div className="w-12 h-12 rounded-xl bg-secondary-200 flex items-center justify-center mb-6 group-hover:bg-white/20 transition-colors duration-300">
              <i className="ri-table-line text-xl text-foreground-700 group-hover:text-background-50 transition-colors duration-300"></i>
            </div>
            <h3 className="text-lg font-bold text-foreground-900 group-hover:text-background-50 transition-colors duration-300">
              {t('features.cards.0.title')}
            </h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed group-hover:text-background-50/80 transition-colors duration-300">
              {t('features.cards.0.desc')}
            </p>
            <span className="inline-flex items-center gap-1 mt-5 text-sm font-medium text-foreground-500 group-hover:text-background-50 transition-colors duration-300">
              Learn more
              <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform duration-300"></i>
            </span>
          </div>

          {/* Card 2 */}
          <div className="group rounded-2xl bg-secondary-50 p-8 hover:bg-primary-500 transition-colors duration-300 cursor-default">
            <div className="w-12 h-12 rounded-xl bg-secondary-200 flex items-center justify-center mb-6 group-hover:bg-white/20 transition-colors duration-300">
              <i className="ri-scales-3-line text-xl text-foreground-700 group-hover:text-background-50 transition-colors duration-300"></i>
            </div>
            <h3 className="text-lg font-bold text-foreground-900 group-hover:text-background-50 transition-colors duration-300">
              {t('features.cards.1.title')}
            </h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed group-hover:text-background-50/80 transition-colors duration-300">
              {t('features.cards.1.desc')}
            </p>
            <span className="inline-flex items-center gap-1 mt-5 text-sm font-medium text-foreground-500 group-hover:text-background-50 transition-colors duration-300">
              Learn more
              <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform duration-300"></i>
            </span>
          </div>

          {/* Card 3 - Blog CTA */}
          <div className="group rounded-2xl bg-secondary-50 p-8 hover:bg-primary-500 transition-colors duration-300 cursor-pointer">
            <div className="w-12 h-12 rounded-xl bg-secondary-200 flex items-center justify-center mb-6 group-hover:bg-white/20 transition-colors duration-300">
              <i className="ri-file-text-line text-xl text-foreground-700 group-hover:text-background-50 transition-colors duration-300"></i>
            </div>
            <h3 className="text-lg font-bold text-foreground-900 group-hover:text-background-50 transition-colors duration-300">
              {t('features.cards.2.title')}
            </h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed group-hover:text-background-50/80 transition-colors duration-300">
              {t('features.cards.2.desc')}
            </p>
            <Link
              to="/itaobuyspreadsheet-guide"
              className="inline-flex items-center gap-1 mt-5 text-sm font-medium text-foreground-500 group-hover:text-background-50 transition-colors duration-300"
            >
              {t('features.blog_cta', 'Read Sourcing Guide →')}
              <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform duration-300"></i>
            </Link>
          </div>
        </div>

        {/* How It Works */}
        <div className="mt-20">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 text-xs font-medium text-foreground-600 mb-6">
              {t('how_it_works.label', 'How It Works')}
            </span>
            <h3 className="text-2xl md:text-3xl font-bold text-foreground-950">
              {t('how_it_works.title')}
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[0, 1, 2].map((i) => (
              <div key={i} className="text-center px-4">
                <div className="w-16 h-16 rounded-full bg-primary-500 text-background-50 flex items-center justify-center mx-auto mb-5">
                  <span className="text-xl font-bold">{t(`how_it_works.steps.${i}.number`)}</span>
                </div>
                <h4 className="text-lg font-bold text-foreground-900 mb-3">
                  {t(`how_it_works.steps.${i}.title`)}
                </h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {t(`how_it_works.steps.${i}.desc`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}